import { Button, Typography, styled } from "@mui/material";

export const StyledOrderHistoryHeading = styled(Typography)({
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "500",
  fontFamily: "Montserrat",
  lineHeight: "24px !important",
});
